module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gc-Hc-Ib-Ja.a7512cee.png";